import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { sortInAlphabeticalOrder } from '../common-helpers/commonServices';





const NEET_PricingsModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);

    let initialData = {
        Section: '',
        Subject: 'Select Subject',
        SubjectID: 0,
        TestCount: 0,
        Price: 0,
        Discount: 0,
        Sn: 0,
    }


    const [examBodyData, setExamBodyData] = useState(initialData);
    console.log(examBodyData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects').then((response) => {
            setSubjects(sortInAlphabeticalOrder(response.data.subjects, 'Subject'));
        }).catch((error) => {
            console.error('Error fetching subjects:', error);
            toast.error('Failed to fetch subjects');
        });
    }, []);



    const hanldeSaveExamBody = async () => {
        try {
            if (!examBodyData.SubjectID || examBodyData.Subject === 'Select Subject') {
                toast.error("Please select Subject")
                return;
            } else if (!examBodyData.Section) {
                toast.error("Please select Class")
                return;
            } else if (examBodyData.TestCount <= 0) {
                toast.error("Please enter valid number of tests")
                return;
            } else if (examBodyData.Price <= 0) {
                toast.error("Please enter valid price")
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/neet/createPlan' : `/neet/updatePlan`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
        }

    }
    return (
        <>
            <Modal onHide={() => setModalBox(false)} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Pricing Plan" : "Add Pricing Plan"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="subjectSelect" className="form-label text-primary">Subject<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Subject, label: examBodyData.Subject }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, Subject: selectedOption.value.Subject, SubjectID: selectedOption.value.Sn })
                                }}
                                options={subjects?.map((subj) => ({ value: subj, label: subj.Subject }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent',
                                        borderColor: '#17a2b8',
                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="sectionSelect" className="form-label text-primary">Class<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Section, label: examBodyData.Section || 'Select Class' }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, Section: selectedOption.value })
                                }}
                                options={[
                                    { value: 'Class-11', label: 'Class-11' },
                                    { value: 'Class-12', label: 'Class-12' },
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent',
                                        borderColor: '#17a2b8',
                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="testCount" className="form-label text-primary">No. of Tests<span className="required">*</span></label>
                            <input className='form-control' type="number" name="" id="testCount" value={examBodyData.TestCount} onChange={(e) => setExamBodyData({ ...examBodyData, TestCount: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="price" className="form-label text-primary">Price<span className="required">*</span></label>
                            <input className='form-control' type="number" name="" id="price" value={examBodyData.Price} onChange={(e) => setExamBodyData({ ...examBodyData, Price: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="discount" className="form-label text-primary">Discount (%)<span className="required">*</span></label>
                            <input className='form-control' type="number" name="" id="discount" value={examBodyData.Discount} onChange={(e) => setExamBodyData({ ...examBodyData, Discount: e.target.value })} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => { setModalBox(false); setExamBodyData(initialData); }}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update Pricing Plan" : "Add Pricing Plan"}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default NEET_PricingsModal;